import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { User, UserStoreService } from '@rms/user';

import { AuthService } from '../services';

export const currentUserResolver: ResolveFn<User | null> = () => {
  const user = inject(AuthService).getCurrentUser();

  if (user) {
    inject(UserStoreService).setUser(user);
  }

  return user;
};
